import React from 'react';

const CrossIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M6.66602 6.66669L13.3327 13.3334" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M13.3327 6.66669L6.66602 13.3334" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default CrossIcon;
